import { expressionDefinitionApiV2, feeTypePricingApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const FEE_TYPES_ACTION_TYPE = createNamedActions('feeTypes', {
  GET_FEE_TYPES: 'GET_FEE_TYPES',
  CREATE_FEE_TYPE: 'CREATE_FEE_TYPE',
  EDIT_FEE_TYPE: 'EDIT_FEE_TYPE',
  DELETE_FEE_TYPE: 'DELETE_FEE_TYPE',
  CREATE_OR_UPDATE_OVERRIDE: 'CREATE_OR_UPDATE_OVERRIDE',
  DELETE_OVERRIDE: 'DELETE_OVERRIDE',
  GET_SCHEMA: 'GET_SCHEMA',
});

const feeTypesSchema = new schema.Entity('data', {}, { idAttribute: 'feeTypeId' });

export const getFeeTypeByCalculationTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await feeTypePricingApi.getFeeTypes(params);

  return dispatch({
    type: FEE_TYPES_ACTION_TYPE.GET_FEE_TYPES,
    payload: normalize(data, [feeTypesSchema]).entities.data,
  });
});

export const createFeeTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await feeTypePricingApi.createFeeType(params);

  return dispatch({
    type: FEE_TYPES_ACTION_TYPE.CREATE_FEE_TYPE,
    payload: data,
    meta: {
      feeTypeId: data.feeTypeId,
    },
  });
});

export const editFeeTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await feeTypePricingApi.editFeeType(params);

  return dispatch({
    type: FEE_TYPES_ACTION_TYPE.EDIT_FEE_TYPE,
    payload: data,
    meta: {
      feeTypeId: params.feeTypeId,
    },
  });
});

export const deleteFeeTypeAction = catchAsyncActionError(params => async dispatch => {
  await feeTypePricingApi.deleteFeeType(params);

  return dispatch({
    type: FEE_TYPES_ACTION_TYPE.DELETE_FEE_TYPE,
    meta: params,
  });
});

export const createOrUpdateOverrideAction = catchAsyncActionError(
  ({ feeTypeId, ...body }) =>
    async dispatch => {
      const { data } = await feeTypePricingApi.createOrUpdateOverride({ feeTypeId, ...body });

      return dispatch({
        type: FEE_TYPES_ACTION_TYPE.CREATE_OR_UPDATE_OVERRIDE,
        payload: data,
        meta: { feeTypeId },
      });
    },
);

export const deleteOverrideAction = catchAsyncActionError(({ feeTypeId }) => async dispatch => {
  await feeTypePricingApi.deleteOverride({ feeTypeId });

  return dispatch({
    type: FEE_TYPES_ACTION_TYPE.DELETE_OVERRIDE,
    meta: { feeTypeId },
  });
});

export const getFeeTypesSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApiV2.getFeeTypeExpressionDefinition();

  return dispatch({
    type: FEE_TYPES_ACTION_TYPE.GET_SCHEMA,
    payload: data,
  });
});

export const resetFeeTypesAction = () => ({
  type: FEE_TYPES_ACTION_TYPE.GET_FEE_TYPES,
});
